import { ChangeDetectorRef, Component } from '@angular/core';
import { VehicleRepairStoreService } from '../repairer-downtime.service';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CardBodyComponent, CardComponent, CardHeaderComponent, SmartTableModule, SpinnerModule } from '@coreui/angular-pro';
import { SecondToDaysHoursMinutes } from '../second-to-days-hours-minutes.pipe';
import { IAvgTimeRepairer } from '../../../../models/vehicle-repair.model';

@Component({
  selector: 'app-average-time-repairer',
  standalone: true,
  imports: [
    CommonModule, 
    CardComponent,
    CardBodyComponent,
    CardHeaderComponent,
    RouterLink, SmartTableModule, SpinnerModule, 
    SecondToDaysHoursMinutes
  ],
  templateUrl: './average-time-repairer.component.html',
  styleUrl: './average-time-repairer.component.scss',
})
export class AverageTimeRepairerComponent {
  vehicleRepairData: IAvgTimeRepairer[] | [] = [];
  VehicleRepairDataSubscription!: Subscription;
  repairerDataSubscription$!: Subscription;
  loadingSubscription$!: Subscription;
  isLoading!:boolean;
  constructor(
    private VehicleRepairStoreService: VehicleRepairStoreService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // this.isLoading = true;
    // this.VehicleRepairDataSubscription = this.VehicleRepairStoreService.vehicleRepairDataObservable.subscribe(
    //   (data) => {
    //     debugger
    //     this.vehicleRepairData = data;
    //     console.log('VehicleRepairDataSubscription: ' , data)
    //     this.isLoading = false;
    //     console.log('setIsloading to false', this.isLoading)
    //     this.cd.detectChanges();
    //   }
    // );

      // Subscribe to the data observables
      this.repairerDataSubscription$ =  this.VehicleRepairStoreService.vehicleRepairDetailData.subscribe(data => { 
        console.log('subcribed to the repairerDataSubscription ', data);
        this.vehicleRepairData = data;
        this.cd.detectChanges();
      });
      this.loadingSubscription$ =  this.VehicleRepairStoreService.isLoading.subscribe(data => { 
        this.isLoading = data;
      });

  }

  ngOnDestroy() {
    // this.VehicleRepairDataSubscription.unsubscribe();
    this.repairerDataSubscription$.unsubscribe();
  }
}
